module.exports = __webpack_public_path__ + "static/media/ic_navigation_double_arrow_right.898a36b3.svg";